export const AnalyticsConfig = (isMobile, source) => ({
  // eslint-disable-next-line
  profile: isMobile ? 'MOBILE' : 'DESKTOP',
  source
});
